
import ConfirmDialog from 'ui-kit/src/components/ConfirmDialog';

export default {
    props: {
        to: [String, Object],
        exact: Boolean,
        confirm: Object,
    },

    methods: {
        onClick() {
            if (this.confirm) {
                this.$q.dialog({
                    component: ConfirmDialog,
                    title: this.confirm.title,
                    message: this.confirm.message,
                    okLabel: 'Přejít',
                    cancelLabel: 'Zpět',
                }).onOk(() => {
                    this.onClickSync();
                });
            } else {
                this.onClickSync();
            }
        },
        onClickSync() {
            if (this.$router.resolve(this.to).href !== this.$route.path) {
                this.$router.push(this.to);
            }
        },
    },
};
